import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useState, useEffect } from "react";
import moment from "moment";
import Select from "react-select";
import JackpotWinnerServices from "../../../services/JackpotWinnerServices";

// Validation Schema
const validationSchema = Yup.object().shape({
  date_filter: Yup.string().required("Date filter is required"),
  session_id: Yup.string().required("Please select a session"),
  winner_yantras: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least 1 winner")
    .required("Winner yantras are required"),
});

const CreateJackpotWinnerModal = (props) => {
  const { show, setShow, activeGame, gameLabel, getJackpotWinnerData, yantraList } =
    props;

  const jackpotWinnerApi = new JackpotWinnerServices();
  const [isLoading, setIsLoading] = useState(false);
  const [sessionList, setSessionList] = useState([]);

  const dateOptionsList = [
    { value: "today", label: "Today" },
    { value: "tomorrow", label: "Tomorrow" },
  ];

  const initialValues = {
    date_filter: "today",
    winner_yantras: [],
    session_id: "",
  };
  const onClose = () => {
    setShow(false);
  };

  const getSessionList = async (date_filter) => {
    try {
      const response = await jackpotWinnerApi.getSessionList(
        activeGame,
        date_filter,
      );
      if (response.isSuccess) {
        const dataList = response.data;
        const optionList = dataList.map((item) => ({
          id: item.id,
          value: item.session_no,
          label: `${moment(item.start_time).format("hh:mm A")} - ${moment(item.end_time).format("hh:mm A")}`,
        }));
        setSessionList(optionList);
      } else {
        setSessionList([]);
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error in getSessionList:", error);
      setSessionList([]);
      toast.error("Error in get session list");
    }
  };

  useEffect(() => {
    if (show) {
      getSessionList(initialValues.date_filter);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      size="md"
    >
      <div className="modal-header border-0 pb-0">
        <h5 className="modal-title">
          Add Multi Winner [
          {gameLabel || activeGame} Session]
        </h5>
        <button className="btn" onClick={onClose}>
          <RiCloseLargeFill size={20} />
        </button>
      </div>
      <hr className="my-1" />
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setIsLoading(true);
          setSubmitting(true);
          const payload = {
            game: activeGame,
            date_filter: values.date_filter,
            session_id: values.session_id,
            winner_count: (values.winner_yantras || []).length,
            winner_yantras: (values.winner_yantras || []).join(","),
          };
          jackpotWinnerApi
            .createJackpotWinner(payload)
            .then((response) => {
              if (response.isSuccess) {
                toast.success(response.message);
                onClose();
                getJackpotWinnerData();
              } else {
                toast.error(response.message);
              }
            })
            .catch((error) => {
              console.error("Error in createJackpotWinner:", error);
              toast.dismiss();
              toast.error(
                error?.response?.data?.message ||
                  "Error in create jackpot winner",
              );
            })
            .finally(() => {
              setIsLoading(false);
              setSubmitting(false);
            });
        }}
      >
        {({ errors, touched, isSubmitting, values, setFieldValue }) => (
          <Form className="addAdmin-form">
            <Modal.Body className="modal-body-scroll">
              <div className="form-group mb-2">
                <label htmlFor="date_filter" className="form-label mb-0">
                  Date Filter <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Select
                    className="mt-1 w-100"
                    options={dateOptionsList}
                    value={dateOptionsList.find(
                      (option) => option.value === values.date_filter,
                    )}
                    id="date_filter"
                    name="date_filter"
                    onChange={(selectedItems) => {
                      setFieldValue("date_filter", selectedItems.value);
                      getSessionList(selectedItems.value);
                    }}
                  />
                </div>
                <ErrorMessage name="date_filter">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>
              <div className="form-group mb-2">
                <label htmlFor="session_id" className="form-label mb-0">
                  Select Session <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Select
                    className="mt-1 w-100"
                    options={sessionList}
                    value={sessionList.find(
                      (option) => option.id === values.session_id,
                    )}
                    id="session_id"
                    name="session_id"
                    onChange={(selectedItems) => {
                      setFieldValue("session_id", selectedItems.id);
                    }}
                  />
                </div>
                <ErrorMessage name="session_id">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>

              <div className="form-group mb-2">
                <label htmlFor="winner_yantras" className="form-label mb-0">
                  Select Winners <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Select
                    className="mt-1 w-100"
                    options={
                      yantraList && yantraList.length > 0
                        ? yantraList.map((y, idx) => ({
                            value: y.id,
                            label: `[${idx + 1}] ${y.yantra_name}`,
                          }))
                        : []
                    }
                    value={
                      yantraList && yantraList.length > 0
                        ? yantraList
                            .map((y, idx) => ({
                              value: y.id,
                              label: `[${idx + 1}] ${y.yantra_name}`,
                            }))
                            .filter((opt) =>
                              (values.winner_yantras || []).includes(opt.value),
                            )
                        : []
                    }
                    id="winner_yantras"
                    name="winner_yantras"
                    onChange={(selectedItems) => {
                      const list = Array.isArray(selectedItems)
                        ? selectedItems.map((y) => y.value)
                        : [];
                      setFieldValue("winner_yantras", list);
                    }}
                    isMulti={true}
                  />
                </div>
                <ErrorMessage name="winner_yantras">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>
              {/* Submit Button */}
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="submit"
                  className="add_admin-btn"
                  disabled={isSubmitting || isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : (
                    "Add Now"
                  )}
                </button>
              </div>
            </Modal.Body>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CreateJackpotWinnerModal;
